import React from 'react';
import Sidebar from './Sidebar';
import FloatingActionButton from './FloatingActionButton';

const Layout = ({ children }) => {
  return (
    <div className="flex h-screen bg-slate-50 overflow-hidden">
      <Sidebar />
      <main className="flex-1 overflow-y-auto pt-14 lg:pt-0">
        {children}
      </main>
      <FloatingActionButton />
    </div>
  );
};

export default Layout;
